import React from "react";
import { Box, Text, SimpleGrid, Flex, Stack, PseudoBox } from "@chakra-ui/core";
import CustomLink from "components/shared/CustomLink";
import GoogleIcon from "svg/icons/google.svg";
import FacebookIcon from "svg/icons/facebook.svg";

const FooterLink = ({ name, href }) => {
  return (
    <Box py="2px">
      <CustomLink href={href} color="#7A7A7A" _hover={{ color: "white" }}>
        {name}
      </CustomLink>
    </Box>
  );
};

const Footer = (props) => {
  return (
    <>
      <Box bg="black" pt="16" pb="8">
        <Box maxW="7xl" mx="auto" px={{ base: "4", base: "6", lg: "8" }} overflow="hidden">
          <SimpleGrid
            columns={{ base: 2, lg: 4 }}
            as="nav"
            display="flex"
            flexWrap="wrap"
            justifyContent="space-between"
            align="flex-start"
          >
            <Box w={{ base: "50%", lg: "25%" }}>
              <Box as="span" fontSize="lg" color="white" fontWeight="semibold">
                Restaurant
              </Box>
              <Box mt="2">
                <FooterLink name="Adresse" href="https://lacitadelle-stfons.fr/#acces" />
                <FooterLink name="Horaires" href="https://lacitadelle-stfons.fr/#acces" />
                <FooterLink name="Contact" href="https://lacitadelle-stfons.fr/contact" />
                <FooterLink name="Commander" href="/" />
              </Box>
            </Box>
            <Box w={{ base: "50%", lg: "25%" }}>
              <Box as="span" fontSize="lg" color="white" fontWeight="semibold">
                Menu
              </Box>
              <Box mt="2">
                <FooterLink name="Voir le menu" href="/" />
                <FooterLink name="Burgers" href="/#burgers" />
                <FooterLink name="Pizzas" href="/#pizzas" />
                <FooterLink name="Tacos & Sandwiches" href="/#sandwiches" />
              </Box>
            </Box>
            <Box w={{ base: "50%", lg: "25%" }} mt={{ base: "8", lg: "0" }}>
              <Box as="span" fontSize="lg" color="white" fontWeight="semibold">
                À propos
              </Box>
              <Box mt="2">
                <FooterLink name="Nos engagements" href="https://lacitadelle-stfons.fr/a-propos" />
                <FooterLink name="Questions fréquentes" href="https://lacitadelle-stfons.fr/a-propos#questions" />
                <FooterLink name="Contact" href="https://lacitadelle-stfons.fr/contact" />
              </Box>
            </Box>
            <Box w={{ base: "50%", lg: "25%" }} mt={{ base: "8", lg: "0" }}>
              <Box as="span" fontSize="lg" color="white" fontWeight="semibold">
                Légal
              </Box>
              <Box mt="2">
                <FooterLink name="Mentions légales" href="https://lacitadelle-stfons.fr/mentions-legales" />
              </Box>
            </Box>
          </SimpleGrid>

          <Box mt="12">
            <Text fontSize="sm" textAlign="center" color="#7A7A7A">
              Pour votre santé, mangez au moins cinq fruits et légumes par jour. www.mangerbouger.fr​
            </Text>
          </Box>
        </Box>
      </Box>
      <Box bg="#333">
        <Flex
          maxW="7xl"
          mx="auto"
          py="4"
          px={{ base: "4", sm: "6", lg: "8" }}
          overflow="hidden"
          align="center"
          justify={{ base: "center", sm: "space-between" }}
          flexDirection={{ base: "column", sm: "row" }}
        >
          <Text color="gray.400" fontWeight="medium" fontSize="sm">
            © 2021 La Citadelle - Tous droits réservés.
          </Text>
          <Stack isInline spacing="6" mt={{ base: 4, sm: 0 }}>
            <Box
              as="a"
              target="_blank"
              href="https://search.google.com/local/reviews?placeid=ChIJVQby6eDp9EcRSfkkzedXUVM"
            >
              <PseudoBox as={GoogleIcon} size="16px" fill="gray.500" _hover={{ fill: "white" }} />
            </Box>
            <Box as="a" target="_blank" href="https://www.facebook.com/pages/La-Citadelle/152703868094237">
              <PseudoBox as={FacebookIcon} size="16px" fill="gray.500" _hover={{ fill: "white" }} />
            </Box>
          </Stack>
        </Flex>
      </Box>
    </>
  );
};

export default Footer;
